import _get from 'lodash/get';

import {
    Google,
    GoogleTransformers,
    Pixall,
} from 'reaxl-analytics-handlers';

import getInventoryOwnerById from '@/analytics/utilities/getInventoryOwnerById';
import { isVDP } from '@/analytics/utilities/isVDP';

const { inventoryTransformer: googleInventoryTransformer } = GoogleTransformers;

/**
 * @summary Sends event on View Dealer Inventory link in Alpha carousel
 * @data inventoryId, ownerId, co_txt_url * need owner id in case inventory is not available
 */
export function ownerViewInventory({
    data = {},
    state,
    dataLayer,
}, option) {

    const { inventoryId, ownerId, par = 'alp' } = data;
    const inventoryWithOwner = getInventoryOwnerById(state, inventoryId);

    const cmp = 'view_inv';

    Pixall.sendClickEvent({
        label: cmp,
        eventSource: 'vehicle',
        listingCode: ownerId,
        par,
        inventory: inventoryWithOwner,
    }, dataLayer, option);

    // return data for custom event
    return { cmp, par };
}

/**
 * @summary Sends event on Show Hide Dealer Inventory Carousel
 * @cmp hide_v
 * @data inventoryId, co_txt_url
 * @events event1
 */
export function ownerShowHideInventory({
    data = {},
    state,
    dataLayer,
}, option) {

    const { inventoryId, parentId } = data;
    const inventoryWithOwner = getInventoryOwnerById(state, inventoryId);

    const cmp = 'hide_v';
    const ownerId = _get(inventoryWithOwner, 'owner.id', '');
    const par = parentId || 'alp';

    Pixall.sendClickEvent({
        label: cmp,
        eventSource: 'vehicle',
        listingCode: ownerId,
        par,
        inventory: inventoryWithOwner,
    }, dataLayer, option);

    Google.sendClickEvent({
        eventElement: 'dealer',
        eventResult: 'text-link::view-vehicles',
    }, option);

    // return data for custom event
    return { cmp, par };
}

export function nbaRecentlyViewedImpression(metadata, option = {}) {
    const { dataLayer, state, filterValues, data } = metadata;
    const { inventoryId, hasSavedListings = false, isSimilarListingsEnabled = false } = data;
    const inventory = getInventoryOwnerById(state, inventoryId);
    let labelType;

    if (hasSavedListings) {
        labelType = 'saved-vehicles';
    } else if (isSimilarListingsEnabled) {
        labelType = 'similar-vehicles';
    } else {
        labelType = 'recently-viewed';
    }

    const label = `cta::${labelType}::nba`;
    const pixallPayload = {
        label,
        eventSource: 'application',
        filterValues,
        hasListingType: false,
        inventory,
    };

    const googlePayload = {
        eventResult: label,
        eventElement: 'dealer_rating',
        eventNonInteractive: false,
        eventData: {
            vehicle: googleInventoryTransformer(inventory, { target: 'vehicle', dataLayer }),
        },
    };

    Pixall.sendImpression({ dataLayer }, pixallPayload, option);
    Google.sendImpressions(metadata, googlePayload, option);
    return {};
}

export function recentlyViewedVehicleNBAClick({ dataLayer, state, filterValues, data }, option = {}) {
    const { inventoryId, hasSavedListings = false, isSimilarListingsEnabled = false } = data;
    const inventory = getInventoryOwnerById(state, inventoryId);
    let labelType;

    if (hasSavedListings) {
        labelType = 'saved-vehicles';
    } else if (isSimilarListingsEnabled) {
        labelType = 'similar-vehicles';
    } else {
        labelType = 'recently-viewed';
    }

    const label = `cta::${labelType}::nba`;
    const par = _get(state, 'srp_activeInteraction.parentId', '');

    const pixallPayload = {
        label,
        eventSource: 'vehicle',
        filterValues,
        dataLayer,
        inventory,
        par,
        pixallData: {
            clickTypeToListingType: isVDP(dataLayer),
        },
    };

    const googlePayload = {
        eventResult: label,
        eventElement: 'dealer_rating',
        eventAction: 'tab',
        eventNonInteractive: false,
        eventData: {
            vehicle: googleInventoryTransformer(inventory, { target: 'vehicle', dataLayer }),
        },
    };

    Pixall.sendClickEvent(pixallPayload, dataLayer, option);
    Google.sendClickEvent(googlePayload, option);
    return {};
}

export default {
    ownerShowHideInventory,
    ownerViewInventory,
    nbaRecentlyViewedImpression,
    recentlyViewedVehicleNBAClick,
};
